<div class="html-container">
  <!-- text -->
  <p class="main-title">{{userGuide}}</p>
  <div class="divider"></div>
  <div class="main-container">

    <div *ngIf="isBusy" style="display: flex;justify-content: center;">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="vendorApplications" [innerHTML]="vendorApplications | safe_html" style="height: 100%;">
    </div>

  </div>
</div>